module.exports = __webpack_public_path__ + "img/pattern.f31f6717.png";